var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var DfnPadGeneratorInteractionModel = require('./dfnPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var Dfn3PadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    DfnPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams,withCustomFootprintParams);
};

lib_core.inherit(Dfn3PadGeneratorInteractionModel, DfnPadGeneratorInteractionModel);
Dfn3PadGeneratorInteractionModel.$class = 'Dfn3PadGeneratorInteractionModel';

module.exports = Dfn3PadGeneratorInteractionModel;

Dfn3PadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    DfnPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.oddPadWidthMin = this.shadow("oddPadWidthMin",
        function() {
            return self.data.oddPadWidthMin() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            //update lead span
            self.horizontalLeadToLeadSpanMax(self.horizontalPinPitch() + (self.padWidthMax() + self.oddPadWidthMax()) / 2);
            self.horizontalLeadToLeadSpanMin(self.horizontalPinPitch() + (self.padWidthMin() + value) / 2);

            return self.data.oddPadWidthMin(value * self.getUnitFactor());
        }, [
            self.data.oddPadWidthMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadWidthMax = this.shadow("oddPadWidthMax",
        function() {
            return self.data.oddPadWidthMax() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            //update lead span
            self.horizontalLeadToLeadSpanMax(self.horizontalPinPitch() + (self.padWidthMax() + value) / 2);
            self.horizontalLeadToLeadSpanMin(self.horizontalPinPitch() + (self.padWidthMin() + self.oddPadWidthMin()) / 2);

            return self.data.oddPadWidthMax(value * self.getUnitFactor());
        }, [
            self.data.oddPadWidthMax, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadHeightMin = this.shadow("oddPadHeightMin",
        function() {
            return self.data.oddPadHeightMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadHeightMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadHeightMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadHeightMax = this.shadow("oddPadHeightMax",
        function() {
            return self.data.oddPadHeightMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadHeightMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadHeightMax, this.userSettingsModel.distanceUnit
        ]
    );
};

Dfn3PadGeneratorInteractionModel.prototype.getInspectorElementForPitch = function() {
    var rowPitch = PackageGeneratorInspectorConfig.getValueFixedUnit('d', this.LCLZ('hPinPitch', 'Horizontal Pin Pitch'), this.horizontalPinPitch, this.userSettingsModel.distanceUnit);
    var colPitch = PackageGeneratorInspectorConfig.getValueFixedUnit('e', this.LCLZ('vPinPitch', 'Vertical Pin Pitch'), this.verticalPinPitch, this.userSettingsModel.distanceUnit);

    return [rowPitch, colPitch];
};

Dfn3PadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var normalTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit);
    var oddTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('largerTerminalLength', 'Larger Terminal Length'), false, this.oddPadHeightMin, false, this.oddPadHeightMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalLength, oddTerminalLength];
};

Dfn3PadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    var normalTerminalWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('terminalWidth', 'Terminal Width'), false, this.padHeightMin, false, this.padHeightMax, this.userSettingsModel.distanceUnit);
    var oddTerminalWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b1', this.LCLZ('largerTerminalWidth', 'Larger Terminal Width'), false, this.oddPadWidthMin, false, this.oddPadWidthMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalWidth, oddTerminalWidth];
};

Dfn3PadGeneratorInteractionModel.prototype.componentFamilyList = function() {
    var FamilyList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_34) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_34[t];
        FamilyList.push([this.LCLZ(t, c), c]);
    }
    return FamilyList;
};

Dfn3PadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintDfn3));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForOddPadLengthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForOddPadWidthInCustomFootprint());

    };
    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
}